import { Component, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import {ToastNotificationService} from "../core/toast-notification.service";
import {SuperAdminSettingsService} from "./super-admin-settings.service";
import {AdminSettingsUpdateRequest} from "./DTOs/AdminSettingsUpdateRequest";
import {AdminValue} from "./DTOs/AdminValue";
import {LoginInfo} from "../core/LoginInfo";
import {AdUploadResult} from "../member-ads/DTOs/file-upload-result";
import {MemberAdRequest} from "../member-ads/DTOs/member-ad-request";
import {LoginSettingsUpdateRequest} from "./DTOs/LoginSettingsUpdateRequest";

@Component({
  selector: 'app-super-admin-settings',
  templateUrl: './super-admin-settings.component.html',
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})

export class SuperAdminSettingsComponent {

    constructor(private settingsService: SuperAdminSettingsService,
                private notificationService: ToastNotificationService,
                private blockUI: UIBlockingService) {}

    opacityValue: number = 0.4;
    originalOpacity: number;
    selectedColor: string = '#ffffff';
    originalColor: string;
    //loginPhotoUrl: string = '..\\..\\assets\\images\\login\\login-bg.jpg';
    loginPhotoUrl: string = '';
    loginImage: File;
    showLive: boolean = false;
    NewsEmail: string;
    AdsEmail: string;
    LettersEmail: string;
    DiscountEmail: string;
    ApplicationEmail: string;
    settings: AdminValue[];



    showLiveToggle() {
        this.showLive = !this.showLive;
    }

    ngOnInit(): void {
        this.blockUI.start();
        this.loginImage = null;
        this.getUserSettings();
        this.getLoginInfo();
        this.getPhotoPreview();
    }
    getUserSettings() {
        this.settingsService.GetUserSettings()
            .subscribe({
                next: (data) => {
                    this.settings = data;
                    this.FillOutSettings()
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                }
            });
    }

    getLoginInfo() {
        this.settingsService.GetLoginInfo()
            .subscribe({
                next: (data) => {
                    this.originalColor = data.loginColor;
                    this.originalOpacity = data.loginOverlay;
                    this.selectedColor = data.loginColor;
                    this.opacityValue = data.loginOverlay;
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.blockUI.stop();
                }
            });
    }
    getPhotoPreview() {
        this.settingsService.GetLoginPhoto()
            .subscribe({
                next: (data) => {
                    this.loginPhotoUrl = data.loginPhoto;
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                },
            });
    }

    FillOutSettings() {
        this.NewsEmail = this.GetSettingValue("NewsApprovalEmail").stringValue;
        this.ApplicationEmail = this.GetSettingValue("ApplicationApprovalEmail").stringValue;
        this.AdsEmail = this.GetSettingValue("AdvertisementApprovalEmail").stringValue;
        this.DiscountEmail = this.GetSettingValue("DiscountApprovalEmail").stringValue;
        this.LettersEmail = this.GetSettingValue("LetterApprovalEmail").stringValue;
    }

    GetSettingValue(itemKey: string) {
        return this.settings.filter(x => x.itemKey == itemKey)[0]
    }

    SaveNewSettings() {
        let req = new AdminSettingsUpdateRequest();
        req.NewsEmail = this.NewsEmail;
        req.AdvertisementEmail = this.AdsEmail;
        req.ApplicationEmail = this.ApplicationEmail;
        req.DiscountEmail = this.DiscountEmail;
        req.LetterEmail = this.LettersEmail;
        this.blockUI.start();
        this.settingsService.UpdateUserSettings(req)
            .subscribe({
                next: (data) => {
                    console.log('Observable emitted the next value: ' + data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.notificationService.success("Successfully updated settings");
                    this.blockUI.stop();
                }
            });
    }

    SaveLoginSetting() {
        this.blockUI.start();
        if(this.loginImage == null) this.submitLoginSettings("");
        else {
            this.uploadFile()
                .subscribe({
                    next: (data: AdUploadResult) => {
                        this.submitLoginSettings(data.fileStorageId);
                    },
                    error: (err) => {
                        console.log(err);
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                    }
                });
        }
    }

    submitLoginSettings(loginImageId: string) {
        let req = new LoginSettingsUpdateRequest()
        req.PhotoId = loginImageId;
        req.Color = this.selectedColor == this.originalColor ? "" : this.selectedColor;
        req.Overlay = this.opacityValue == this.originalOpacity ? null : this.opacityValue;
        this.settingsService.UpdateLoginSettings(req)
            .subscribe({
                next: (data) => {
                    console.log('Observable emitted the next value: ' + data);
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    console.log('Observable emitted the complete notification');
                    this.notificationService.success("Successfully submitted ad");
                    this.blockUI.stop();
                }
            });
    }

    updateLoginImage(files: FileList) {
        this.loginImage = files.item(0);
        const reader = new FileReader();

        reader.onload = (e: any) => {
            this.loginPhotoUrl = e.target.result;
        }
        reader.readAsDataURL(files.item(0));
    }

    uploadFile() {
        const uploadData = new FormData();
        uploadData.append('mainImage', this.loginImage, this.loginImage.name);
        return this.settingsService.uploadLoginPhoto(uploadData);
    }
}
